import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getGroupPlayers } from '../../api/getGroupPlayers';
import { setMatchOver } from '../../api/setMatchOver';
import { getRoundMatches } from '../../api/getRoundMatches';
import * as func from '../../utils/funcs';

import BasicButtons from '../../partials/BasicButtons';
import FooterMenu from '../../partials/FooterMenu';
import HeaderTopic from '../../partials/HeaderTopic';
import PrimaryButton from './../../partials/PrimaryButton';
import GoalForm from './GoalForm/GoalForm';
import GreenCardForm from './GreenCardForm/GreenCardForm';
import MatchSum from './MatchSum/MatchSum';

import styles from './MatchReport.module.css';
import GreenCard from './../../graphics/elements/greenCard.svg';
import GoalGate from './../../graphics/elements/goalGate.png';
import WhisleWhite from './../../graphics/icons/whisle-white.svg';

function MatchReport(props) {
  const { user, league, matches, setMatches, refreshStates } = props;
  const { leagueId, roundId, matchId } = useParams();
  const history = useHistory();

  const matchInfo = matches.filter(match => match.id === parseInt(matchId, 10))[0];

  const [selectedTeam, setSelectedTeam] = React.useState(matchInfo.teams[0].id);
  const [selectedAction, setSelectedAction] = React.useState('goal');
  const [teamPlayers1, setTeamPlayers1] = React.useState([]);
  const [teamPlayers2, setTeamPlayers2] = React.useState([]);
  const [isFinalizing, setIsFinalizing] = React.useState(false);

  React.useEffect(() => {
    getGroupPlayers(leagueId, matchInfo.teams[0].id).then(data => {
      setTeamPlayers1(data);
    });

    getGroupPlayers(leagueId, matchInfo.teams[1].id).then(data => {
      setTeamPlayers2(data);
    });
  }, [leagueId, matchInfo]);

  const handleClickResolveMatch = async () => {
    setIsFinalizing(true);
    try {
      const res = await setMatchOver(leagueId, roundId, matchId);
      if (!res.error) {
        const res2 = await getRoundMatches(leagueId, roundId);
        setMatches(res2);
        history.push(`/leagues/${leagueId}/rounds/${roundId}`);
      } else {
        console.error('Error finalizing match:', res.error);
      }
    } catch (error) {
      console.error('Error finalizing match:', error);
    } finally {
      setIsFinalizing(false);
    }
  };

  const match = func.reFormatMatchData(matchInfo);

  return (<div className={styles.matchReport}>
      <HeaderTopic topic={'ליגת ' + league.name} />
      <BasicButtons user={user} refreshStates={refreshStates} />
      <FooterMenu setActive={'vs'} />
      <h2>דיווח תוצאת משחק</h2>
      <div className={styles.scrollable}>
        <div className={styles.teamsBtns}>
          <div
            className={selectedTeam === match.teams[0].id ? styles.activeTeam :
              styles.nonBtn}
            onClick={() => setSelectedTeam(match.teams[0].id)}
          >
            {match.teams[0].name}
          </div>

          <div
            className={selectedTeam === match.teams[1].id ? styles.activeTeam :
              styles.nonBtn}
            onClick={() => setSelectedTeam(match.teams[1].id)}
          >
            {match.teams[1].name}
          </div>
        </div>

        <div className={styles.ctaBtns}>
          <div
            className={selectedAction === 'goal' ? styles.activeCta : styles.nonBtn}
            onClick={() => {
              setSelectedAction('goal');
            }}
          >
            <img src={GoalGate} alt="כרטיס ירוק" />
            דיווח שער
          </div>

          <div
            className={selectedAction === 'greenCarc' ? styles.activeCta : styles.nonBtn}
            onClick={() => {
              setSelectedAction('greenCarc');
            }}
          >
            <img src={GreenCard} alt="כרטיס ירוק" />
            דיווח כרטיס ירוק
          </div>
        </div>

        <div className={styles.flexForms}>
          <div
            className={styles.theForms}
            style={selectedAction === 'goal' ? { right: 0 } : { right: '-100vw' }}
          >
            <div>
              <GoalForm
                teamId={selectedTeam}
                againstId={matchInfo.teams.filter(team => team.id !== selectedTeam)[0].id}
                players={selectedTeam === matchInfo.teams[0].id ? teamPlayers1 :
                  teamPlayers2}
                setMatches={setMatches}
              />
            </div>

            <div>
              <GreenCardForm teamId={selectedTeam} setMatches={setMatches} />
            </div>
          </div>

          <div className={styles.matchSum}>
            {/* Goals table for the match */}
            <MatchSum match={match} setMatches={setMatches} />
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' ,marginTop: '20px' }}>
              <PrimaryButton
                text={<span
                  style={{ display: 'flex', alignItems: 'center', color: 'white' , width: '100%' }}>
                  קביעת תוצאת המשחק

                </span>}
                onClick={handleClickResolveMatch}
                loading={isFinalizing}
                disabled={isFinalizing}
                size="large"
                type="button"
              />
            </div>
          </div>
        </div>
      </div>
    </div>);
}

export default MatchReport;
